import { useEffect } from 'react'
import { toast } from 'sonner'
import type { Lang } from '@/types/lang'
import { parseStartError } from '@/features/ai/lib/parseStartError'
import { translationPublishFailureText } from '@/features/ai/lib/translationPublishFailureText'
import { VisibilitySwitch } from '../course-settings/VisibilitySwitch'
import { useTranslationPublishToggle } from '../course-settings/useTranslationPublishToggle'
import { useMessages } from '@/i18n'
import { messages } from './messages'

interface Props {
  courseId: number
  lang: Lang
  isPublished: boolean
  disabled: boolean
}

/**
 * Тумблер языка в меню шапки: ПОКАЗАТЬ / СКРЫТЬ язык у учеников (публикация
 * строки перевода), а не удалить его. Удаление — необратимое, с текстом
 * перевода — живёт только в настройках курса (вкладка «Язык»). Та же ручка и
 * тот же хук, что у тумблера во вкладке, поэтому два места не разойдутся.
 * Отказ — тостом: меню к ответу обычно уже закрыто, строке ошибки жить негде.
 */
export const LangVisibilitySwitch = ({ courseId, lang, isPublished, disabled }: Props) => {
  const m = useMessages(messages)
  const publish = useTranslationPublishToggle(courseId, lang, isPublished)
  useEffect(() => {
    if (publish.error) toast.error(translationPublishFailureText(parseStartError(publish.error)))
  }, [publish.error])
  return (
    <VisibilitySwitch
      label={m.langVisible(lang)}
      hint={publish.checked ? m.langShown : m.langHidden}
      checked={publish.checked}
      pending={publish.isSaving}
      disabled={disabled || publish.isSaving}
      onCheckedChange={publish.toggle}
    />
  )
}
